"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registry = void 0;
var children = new Map();
var sessionIdIndex = 0;
exports.registry = {
  bookId: function bookId() {
    return "x:" + sessionIdIndex++;
  },
  register: function register(id, actor) {
    children.set(id, actor);
    return id;
  },
  get: function get(id) {
    return children.get(id);
  },
  free: function free(id) {
    children.delete(id);
  }
};